<template>
    <div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon" v-on="$listeners"/>
    <svg v-else :class="className" aria-hidden="true" v-on="$listeners">
      <use :xlink:href="iconName"/>
    </svg>
</template>

<script>
  import { isExternal } from '@/utils/validate'

  export default {
    name: 'SvgIcon',
    props: {
      name: {
        type: String,
        required: true
      },
      className: {
        type: String,
        default: ''
      }
    },
    computed: {
      isExternal () {
        return isExternal(this.name)
      },
      iconName () {
        return `#icon-${this.name}`
      },
      styleExternalIcon () {
        return {
          mask: `url(${this.name}) no-repeat 50% 50%`,
          '-webkit-mask': `url(${this.name}) no-repeat 50% 50%`
        }
      }
    }
  }
</script>

<style scoped>
  svg {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
  }

  .svg-external-icon {
    width: 1em;
    height: 1em;
    background-color: currentColor;
    mask-size: cover !important;
    display: inline-block;
  }
</style>
